/**
 * One shared "catch up with storage" primitive.
 *
 * Both the 409 path in `useAutosave` and the tab channel call this, so there is
 * exactly one way another tab's work enters a running editor — read the plan,
 * merge it, keep whatever of ours storage has not seen.
 */

import { usePlanStore } from '../store/planStore'
import { api } from './api'

export async function pullAndIntegrate(planId: string): Promise<boolean> {
  try {
    const stored = await api.getPlan(planId)
    usePlanStore.getState().integrateStoredPlan(stored)
    return true
  } catch {
    // Deleted in another tab, or storage failed. The caller decides what next:
    // the autosave shows its error banner, the tab channel retries on focus.
    return false
  }
}
